export enum ExampleOrigin {
    IMPORT = "IMPORT",
    MANUAL = "MANUAL",
    SYNTHESIS = "SYNTHESIS",
    PLAYGROUND = "PLAYGROUND",
}
